import React from 'react';

import Coachmark from '../coachmark/coachmark';

import styles from './graded-cta.module.scss';

function GradedCta() {
  return (
    <>
      <div className={styles.cta}>
        <Coachmark
          position="right"
          showArrow={true}
          label={
            <>
              To see results, accept the honor code and submit your answers below. Close full screen
              first if using.
            </>
          }
        />
      </div>
      <div className={styles.mobile}>
        <Coachmark
          position="right"
          showArrow={false}
          label={
            <>
              To see results, accept the honor code and submit your answers below. Close full screen
              first if using.
            </>
          }
        />
      </div>
    </>
  );
}

export default GradedCta;
